import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import { environment } from 'src/environments/environment';
import {catchError} from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  public baseUrl = environment.apiBaseUrl;
  public baseUrl2 = environment.apiBaseUrl2;
  constructor(protected http: HttpClient) {}

    get<T>(
    endpoint: string,
    options: {
      headers?:
        | HttpHeaders
        | {
            [header: string]: string | string[];
          };
      params?:
        | HttpParams
        | {
            [param: string]: string | string[];
          };
    } = {}
  ): Observable<T> {
    if(options.params){
    }
    return this.http.get<T>(this.buildUrl(endpoint), options).pipe(catchError(err => {
      return throwError(err);
    }) );
  }
  get2<T>(
    endpoint: string,
    options: {
      headers?:
        | HttpHeaders
        | {
        [header: string]: string | string[];
      };
      params?:
        | HttpParams
        | {
        [param: string]: string | string[];
      };
    } = {}
  ): Observable<T> {
    return this.http.get<T>(this.buildUrl2(endpoint), options).pipe(catchError(err => {
      return throwError(err);
    }) );
  }

  post<T>(
    endpoint: string,
    body?: any | null,
    options: {
      headers?:
        | HttpHeaders
        | {
            [header: string]: string | string[];
          };
      params?:
        | HttpParams
        | {
            [param: string]: string | string[];
          };
    } = {}
  ): Observable<T> {
    return this.http.post<T>(this.buildUrl(endpoint), body, options).pipe(catchError(err => {
      return throwError(err);
    }) );
  }

  post2<T>(
    endpoint: string,
    body?: any | null,
    options: {
      headers?:
        | HttpHeaders
        | {
        [header: string]: string | string[];
      };
      params?:
        | HttpParams
        | {
        [param: string]: string | string[];
      };
    } = {}
  ): Observable<T> {
    return this.http.post<T>(this.buildUrl2(endpoint), body, options).pipe(catchError(err => {
      return throwError(err);
    }) );
  }

  patch<T>(
    endpoint: string,
    body?: any | null,
    options: {
      headers?:
        | HttpHeaders
        | {
            [header: string]: string | string[];
          };
      params?:
        | HttpParams
        | {
            [param: string]: string | string[];
          };
    } = {}
  ): Observable<T> {
    return this.http.patch<T>(this.buildUrl(endpoint), body, options).pipe(catchError(err => {
      return throwError(err);
    }) );
  }

  put<T>(
    endpoint: string,
    body?: any | null,
    options: {
      headers?:
        | HttpHeaders
        | {
            [header: string]: string | string[];
          };
      params?:
        | HttpParams
        | {
            [param: string]: string | string[];
          };
    } = {}
  ): Observable<T> {
    return this.http.put<T>(this.buildUrl(endpoint), body, options).pipe(catchError(err => {
      return throwError(err);
    }) );
  }

  delete<T>(
    endpoint: string,
    options: {
      headers?:
        | HttpHeaders
        | {
            [header: string]: string | string[];
          };
      params?:
        | HttpParams
        | {
            [param: string]: string | string[];
          };
    } = {}
  ): Observable<T> {
    return this.http.delete<T>(this.buildUrl(endpoint), options).pipe(catchError(err => {
      return throwError(err);
    }) );
  }

  delete2<T>(
    endpoint: string,
    options: {
      headers?:
        | HttpHeaders
        | {
        [header: string]: string | string[];
      };
      params?:
        | HttpParams
        | {
        [param: string]: string | string[];
      };
    } = {}
  ): Observable<T> {
    return this.http.delete<T>(this.buildUrl2(endpoint), options).pipe(catchError(err => {
      return throwError(err);
    }) );
  }
  protected buildUrl(url: string): string {
    return `${this.baseUrl}/${url.replace(/^\/+/g, '')}`;
  }
  protected buildUrl2(url: string): string {
    return `${this.baseUrl2}/${url.replace(/^\/+/g, '')}`;
  }
}
